export enum ApiQueryKeys {
  TOKEN = 'token',
  PREVIEW_COURSE = 'previewCourse',
  PREVIEW_COURSES = 'previewCourses',
}
